<div class="graph" fxLayout="column" fxLayoutAlign="space-between stretch" fxFill>
  <form [formGroup]="graphForm" fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="20px">
    <dashboard-module-item-core [dialogData]="dialogData" formControlName="moduleItemCore"></dashboard-module-item-core>
    <div fxLayout="column">
      <mat-tab-group
        mat-align-tabs="end"
        animationDuration="0ms"
        (selectedTabChange)="dashboardModuleItemCore.selectTemplateLanguage($event); emitPreviewValues()"
        [disablePagination]="true"
        [selectedIndex]="selectedLanguage?.tabIndex"
      >
        <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
          <ng-template matTabContent>
            <div formArrayName="translations" *ngFor="let item of translations?.controls; let i = index">
              <ng-container *ngIf="item.get('language').value === selectedLanguage.code">
                <mat-form-field
                  [formGroupName]="i"
                  fxFlex="100"
                  *ngIf="item.get('identifier').value === ModuleItemAvailableAttribute.BUTTON_LABEL"
                >
                  <input matInput formControlName="translation" placeholder="Button label" />
                  <mat-error *ngIf="item.get('translation').hasError('maxlength')">
                    Button label should have
                    <strong>at most {{ item.get('translation').errors?.maxlength.requiredLength }} </strong>characters
                  </mat-error>
                </mat-form-field>
                <mat-form-field
                  [formGroupName]="i"
                  fxFlex="100"
                  *ngIf="item.get('identifier').value === ModuleItemAvailableAttribute.Y_AXIS"
                >
                  <input matInput formControlName="translation" placeholder="Y axis" />
                  <mat-error *ngIf="item.get('translation').hasError('required')">
                    Y axis name is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="item.get('translation').hasError('maxlength')">
                    Y axis name should have
                    <strong>at most {{ item.get('translation').errors?.maxlength.requiredLength }} </strong>characters
                  </mat-error>
                </mat-form-field>
                <mat-form-field
                  [formGroupName]="i"
                  fxFlex="100"
                  *ngIf="item.get('identifier').value === ModuleItemAvailableAttribute.X_AXIS"
                >
                  <input matInput formControlName="translation" placeholder="X axis" />
                  <mat-error *ngIf="item.get('translation').hasError('required')">
                    X axis name is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="item.get('translation').hasError('maxlength')">
                    X axis name should have
                    <strong>at most {{ item.get('translation').errors?.maxlength.requiredLength }} </strong>characters
                  </mat-error>
                </mat-form-field>
              </ng-container>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
    <div
      class="graph__actions"
      fxLayout="row"
      fxLayoutAlign="space-between center"
      *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.MODULES, PRIVILEGE_ACTIONS.ALL)"
    >
      <button mat-raised-button color="primary" (click)="closeModuleItemDialog()">
        {{ 'Cancel' | uppercase }}
      </button>
      <button mat-raised-button color="primary" (click)="saveModuleItem()">
        {{ 'Save' | uppercase }}
      </button>
    </div>
  </form>
</div>
